import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"

/* Icons */
import { ServerIcon, WifiOffIcon, ShieldLockIcon, KeyIcon, SearchIcon, RefreshIcon } from "./Icons"


/* EVERY STATE THE COMPONENT CAN DRAW — ANYTHING ELSE FALLS BACK TO THE SPINNER */
const STATES = {
    error: { icon: ServerIcon, tone: "red", title: "layout.serverError", text: "layout.serverErrorDesc" },
    network: { icon: WifiOffIcon, tone: "orange", title: "layout.networkError", text: "layout.networkErrorDesc" },
    permission: { icon: ShieldLockIcon, tone: "indigo", title: "layout.noAccess", text: "layout.noAccessDesc" },
    key: { icon: KeyIcon, tone: "blue", title: "layout.invalidKey", text: "layout.invalidKeyDesc", hard: true },
    empty: { icon: SearchIcon, tone: "grey", title: "layout.empty", text: "layout.emptyDesc" },
}


/* Component Layout */
class Layout extends Component {

    /* Draw Button — an expired key is only fixed by a full page reload */
    _button = (hard) => {

        /* Fields */
        const { reload } = this.props

        /* Reload The Page */
        if (hard) {
            return (
                <div onClick={() => window.location.reload()} className="layout--button">
                    <RefreshIcon />
                    <span>{t("layout.reload")}</span>
                </div>
            )
        }

        /* Repeat The Request */
        if (reload) {
            return (
                <div onClick={() => reload()} className="layout--button">
                    <RefreshIcon />
                    <span>{t("layout.retry")}</span>
                </div>
            )
        }

    }

    render = () => {

        /* Fields */
        const { status, inner, light } = this.props

        /* State */
        const state = STATES[status]

        /* Modifiers */
        const className = `layout--box ${inner ? "inner" : ""} ${light ? "light" : ""}`

        /* Loading */
        if (!state) {
            return (
                <div className={className}>
                    <div className="layout--loading" />
                </div>
            )
        }

        /* State Icon */
        const StateIcon = state.icon

        return (
            <div className={className}>

                <div className="layout--card">

                    <div className={`layout--icon ${state.tone}`}>
                        <StateIcon />
                    </div>

                    <h2>{t(state.title)}</h2>
                    <p>{t(state.text)}</p>

                    {this._button(state.hard)}

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps)(Layout)
